



















































import Vue, { PropType } from 'vue';
import SearchBannerDateCalendar from './elements/SearchBannerDateCalendar.vue';
import SearchBannerAmountDropdown from './elements/SearchBannerAmountDropdown.vue';
import SearchBannerCityDropdown from './elements/SearchBannerCityDropdown.vue';
import { sdDevice } from '../../../../../../../frontend/helper/device';
import type { FormLabels, CalendarConfig } from './types';
import SearchBannerFormSkeleton from '../skeletons/SearchBannerFormSkeleton.vue';

export default Vue.extend({
  name: 'SearchBannerForm',
  components: {
    SearchBannerDateCalendar,
    SearchBannerAmountDropdown,
    SearchBannerCityDropdown,
    SearchBannerFormSkeleton,
  },
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    labels: {
      type: Object as PropType<FormLabels>,
      required: true,
    },
    calendarConfig: {
      type: Object as PropType<CalendarConfig>,
    },
  },
  data() {
    return {
      citySlug: '',
      cityActive: false,
      dateActive: false,
      amountActive: false,
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    loading(): boolean {
      return this.$store.getters[`${this.storeNamespace}/isLoading`];
    },
    isDesktop(): boolean {
      return this.windowWidth > sdDevice.breakpoints.tablet;
    },
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    handleCitySelect() {
      requestAnimationFrame(() => {
        this.dateActive = true;
      });
    },
    handleDateSelect() {
      requestAnimationFrame(() => {
        this.amountActive = true;
      });
    },
    handleAmountSelect() {
      if (!this.isDesktop) {
        this.handleSubmit();
      }
    },
    handleSubmit() {
      this.$emit('submit');
    },
  },
});
